import comp from "./PostPreview";

export default comp;
